import {useListViewVariant} from '../ListView/VariantContext'
import {Box, type BoxProps, merge} from '@primer/react'
import {useRef, useEffect} from 'react'
import {useListItemDescription} from './DescriptionContext'
import type {BetterSystemStyleObject} from '@primer/react/lib-esm/sx'
import {testIdProps} from '@github-ui/test-id-props'

const defaultStyles: BetterSystemStyleObject = {fontSize: 0, width: '100%'}

export function ListItemDescriptionItem({children, sx, ...props}: BoxProps) {
  const {variant} = useListViewVariant()
  const {setDescription} = useListItemDescription()
  const ref = useRef<HTMLDivElement>(null)
  const containerStyles = sx ? merge<BetterSystemStyleObject>(defaultStyles, sx) : defaultStyles

  useEffect(() => {
    if (ref.current) {
      // Compose the ListItem description from the aria-label property of the DescriptionItem children
      const childrenAriaLabels = ref.current?.querySelectorAll('[aria-label]')
      let description = Array.from(childrenAriaLabels).reduce((metadataLabel: string, element: Element) => {
        return metadataLabel + element.getAttribute('aria-label')?.trim()
      }, '')
      if (!description && ref.current.textContent) description = ref.current.textContent.trim()
      setDescription(description)
    }
  }, [setDescription])

  return (
    <Box
      ref={ref}
      {...testIdProps('list-view-item-descriptionitem')}
      {...props}
      sx={merge<BetterSystemStyleObject>({display: variant === 'compact' ? 'flex' : 'inline'}, containerStyles)}
    >
      {children}
    </Box>
  )
}

try{ ListItemDescriptionItem.displayName ||= 'ListItemDescriptionItem' } catch {}